export const buttonsWrapperStyles = { gap: '12px', flexWrap: 'wrap' };
